<!--
 ResultList Component
 The component that contains a list of search results (ResultItem)
 devs@droxit.de
 Copyright (c) 2020 droxIT GmbH
-->

<template>

  <b-container fluid="md">
    <b-row id="rocketsearch-result-item-row">
      <b-col v-if="results.total_hits > 0">
        <b-list-group id="rocketsearch-result-list">
          <b-list-group-item class="rocketsearch-result-item"
                             v-for="item in results.results.slice(0, num_results)" v-bind:key="item.id">
            <ResultItem
                :result_item="item"
                :key="refresh_key"
            />
          </b-list-group-item>
        </b-list-group>
      </b-col>
      <b-col v-else class="rocketsearch-no-results" style="padding-left: 10px; padding-right: 10px;">
        <span>
          {{$t('no_results')}}
        </span>
      </b-col>
    </b-row>
  </b-container>

</template>

<script>
  import httpVueLoader from 'http-vue-loader'

  export default {
    name: 'ResultList',
    components: {
      'ResultItem': httpVueLoader(window.__env.config.HTML_TEMPLATE)
    },
    props: {
      results: Object,
      showAllResults: Boolean,
     },
    watch: {
      results: function () {
        this.refresh_key++
      }
    },
    data: function () {
      return{
        refresh_key:0
      }
    },
    computed: {
      num_results: function(){
        if(this.showAllResults){
            return window.__env.config.NUM_ALL_RESULTS;
        } else {
            return window.__env.config.NUM_PREVIEW_RESULTS;
        }
      }
    }
  }
</script>
